module.exports = __webpack_public_path__ + "img/bg.5c1e1979.jpg";